export { default } from "./HistoricoVentasDia";
